import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import Select from "react-select";
import { useParams } from "react-router-dom";
import Picker from "emoji-picker-react";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginMediaPreview from "filepond-plugin-media-preview";
import "filepond-plugin-media-preview/dist/filepond-plugin-media-preview.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import Modal from "react-bootstrap/Modal";
import { groupOptionsByAlphabet } from "shared/helper/updateObject";
import Member from "shared/media/user/userIcon.png";
import { Btn, Button, RenderIf } from "shared/components";
import { useDetailedInfoByIdQuery } from "redux/api/siteUsers";
import { useCreateCommunityDiscussionMutation } from "redux/api/community";
import { useGetInterestsQuery } from "redux/api/interestApi";
import { CreateSchema, initialValues } from "./data";
import "./Card.scss";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginMediaPreview,
  FilePondPluginFileValidateType
);
const CreatePostCommunity = ({ className }) => {
  const { t } = useTranslation();
  const [createDiscussion, { isSuccess, isLoading }] =
    useCreateCommunityDiscussionMutation();
  const { communityId } = useParams();
  const { firstName, lastName, id, position } = useSelector(
    (state) => state.user?.user
  );
  const pickerRef = useRef(null);
  const [options, setOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [inputVal, setInputVal] = useState("");
  const [files, setFiles] = useState([]);
  const { REACT_APP_BASE_PHOTO_URL } = process.env;
  const { data } = useDetailedInfoByIdQuery({ id: id });
  const [showPicker, setShowPicker] = useState(false);
  const [interestOption, setInterestOption] = useState([]);
  const [selectedOptionIds, setSelectedOptionIds] = useState([]);
  const { data: interestedData, isSuccess: interestSuccess } =
    useGetInterestsQuery();
  const handleChangeInterest = (selectedOptions) => {
    const selectedIds = selectedOptions?.map((option) => option.value);
    setSelectedOptionIds(selectedIds);
    setInterestOption(selectedOptions);
  };
  const onEmojiClick = (emojiObject) => {
    const emoji = emojiObject.emoji;
    const textarea = document.getElementById("text");
    const { selectionStart, selectionEnd } = textarea;
    const currentValue = textarea.value;
    const newValue =
      currentValue.slice(0, selectionStart) +
      emoji +
      currentValue.slice(selectionEnd);
    setInputVal(newValue);
    formik.setFieldValue("text", newValue);
    formik.setFieldTouched("text", true);
    formik.setErrors({ ...formik.errors, text: undefined });
    requestAnimationFrame(() => {
      textarea.selectionStart = textarea.selectionEnd =
        selectionStart + emoji.length;
      textarea.focus();
    });
  };
  const handleInputChange = (event) => {
    const newValue = event.target.value.replace(/\n/g, "\r\n");
    setInputVal(newValue);
    formik.setFieldValue("text", newValue);
  };

  const handleShow = () => setShow(true);

  const validationSchema = CreateSchema(files);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: () => {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("Files", files[i].file);
      }
      formData.append("Text", inputVal);
      formData.append("Top", true);
      formData.append("SiteUserId", id);
      formData.append("CommunityId", communityId);
      formData.append("DiscussionType", 1);
      if (selectedOptionIds?.length) {
        for (let i = 0; i < selectedOptionIds?.length; i++) {
          formData.append("Interests", selectedOptionIds?.[i]);
        }
      }
      createDiscussion(formData);
    },
  });
  const getInputClasses = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return true;
    }
    if (formik.touched[fieldName] && !formik.errors[fieldName]) {
      return false;
    }

    return false;
  };

  const handleClose = () => {
    setShow(false);
    setInputVal("");
    setFiles([]);
    formik.resetForm();
    setShowPicker(false);
  };
  React.useEffect(() => {
    if (isSuccess) {
      handleClose();
    }
  }, [isSuccess]);
  useEffect(() => {
    if (interestSuccess) {
      const interestsOptions = interestedData?.data?.map((suggestion) => ({
        value: suggestion?.id,
        label: suggestion?.name,
      }));
      setOptions(interestsOptions);
    }
  }, [interestSuccess]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);
  return (
    <div className={`postCard ${className}`}>
      <div className="postCardOne d-flex align-items-center">
        <div className="postCardOneLeft">
          <img
            alt="user"
            src={
              data?.profilePhotoUrl
                ? `${REACT_APP_BASE_PHOTO_URL}${data?.profilePhotoUrl}`
                : Member
            }
          />
        </div>
        <div className="postCardOneRight">
          <button
            onClick={handleShow}
            className="w-100 text-start d-flex align-items-center">
            {t("newPost")}
          </button>
        </div>
      </div>
      <div className="postCardTwo align-items-center justify-content-between">
        <div className="postCardTwoLeft">
          {/* <Btn border="glassy">{t("needAdvice")}</Btn>
          <Btn border="purple">{t("conveyVisdom")}</Btn> */}
        </div>
      </div>
      <Modal
        size="lg"
        centered
        keyboard={false}
        backdrop="static"
        show={show}
        onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("newPost")}</Modal.Title>
        </Modal.Header>
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body className="overflow-visible">
            <div className="body-div">
              <div className="body-divTop d-flex">
                <div className="body-divTopImg">
                  <img
                    alt="user"
                    src={
                      data?.profilePhotoUrl
                        ? `${REACT_APP_BASE_PHOTO_URL}${data?.profilePhotoUrl}`
                        : Member
                    }
                  />
                </div>
                <div className="body-divTopRight mx-2">
                  <h4>
                    {firstName} {lastName}
                  </h4>
                  <span>{position}</span>
                </div>
              </div>
              <div className="body-divBody" style={{ whiteSpace: "pre-line" }}>
                <textarea
                  className="mb-0 pt_8 emojiField"
                  type="text"
                  value={inputVal}
                  rows="3"
                  cols="30"
                  id="text"
                  name="text"
                  onChange={handleInputChange}
                  placeholder={t("whatTalkAbout")}
                  error={getInputClasses("text")}
                />
                <RenderIf
                  condition={formik.touched.text && formik.errors.text}
                  renderElse={null}>
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.text}</div>
                  </div>
                </RenderIf>
                <div className="body-divBodyEmoji">
                  <div
                    className="body-divBodyEmojiIcon"
                    onClick={() => setShowPicker((val) => !val)}>
                    <InsertEmoticonIcon />
                  </div>
                  <RenderIf condition={showPicker}>
                    <div ref={pickerRef}>
                      <Picker
                        className="emojiPicker"
                        onEmojiClick={onEmojiClick}
                        emojiStyle="apple"
                      />
                    </div>
                  </RenderIf>
                </div>
              </div>
              <div className="w-100 mb-3">
                <Select
                  closeMenuOnSelect={false}
                  placeholder={t("tags")}
                  onChange={handleChangeInterest}
                  value={interestOption}
                  isMulti
                  classNamePrefix="custom-react-select"
                  isSearchable
                  // options={interestsOptions}
                  options={groupOptionsByAlphabet(options)}
                />
              </div>
              <div className="body-divUpload  mt-2">
                <FilePond
                  files={files}
                  onupdatefiles={setFiles}
                  allowMultiple={true}
                  acceptedFileTypes={[
                    "image/*",
                    "video/*",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/vnd.ms-powerpoint",
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "application/pdf",
                    "audio/mpeg",
                  ]}
                  name="files"
                  labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="postCardTwoRight d-flex align-items-center">
              {/* <div className="d-flex align-items-center"></div> */}

              <Button
                disabled={isLoading}
                type="submit"
                className="pt_10_32 mx-2 align-items-center d-flex"
                background="#057953">
                {t("post")}
                <RenderIf condition={isLoading}>
                  <div class="spinner-border" role="status"></div>{" "}
                </RenderIf>
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default CreatePostCommunity;
